module.exports = __webpack_public_path__ + "static/media/1xl-white-logo.85b6d288.png";